exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newsBlock {\n  color: #000;\n  font-size: 15px;\n  font-family: 'Roboto';\n  line-height: 1.33;\n}\n\n@media screen and (max-width:480px) {\n  .newsBlock {\n    font-size: 14px;\n  }\n}", ""]);

// exports
